import React from 'react';
import RecordersTable from 'src/features/milestones/recorders/RecordersTable';
import MilestonesContent from './layout/MilestonesContent';

const RecordersPage = () => {
  return <MilestonesContent contentType="table" content={<RecordersTable />} />;
};

export default RecordersPage;
